module.exports = __webpack_public_path__ + "static/media/newUserPage.4bf53d34.svg";